import { equalsDeep } from '@repo/utils';
import { action, computed, makeObservable, observable } from 'mobx';
import { v4 } from 'uuid';

import type { TFactTrajectoryPoint } from '../model';

export type TPointData = TFactTrajectoryPoint;

export class FactTrajectoryPointEntity {
  readonly entityId = v4();

  readonly isParentStation: boolean;

  @observable.ref private _initialData: TPointData = {};

  @observable.ref data: TPointData = {};

  constructor(initialData?: Partial<TFactTrajectoryPoint>, isParentStation = false) {
    this.isParentStation = isParentStation;
    this._initialData = initialData ?? {};
    this.data = initialData ?? {};

    makeObservable(this);
  }

  get initialData(): TPointData {
    return this._initialData;
  }

  @computed
  get hasChanges(): boolean {
    return !equalsDeep(this.data, this._initialData);
  }

  @action.bound
  updateData(data: Partial<TPointData>): void {
    this.data = { ...this.data, ...data };
  }

  @action.bound
  commitData(): void {
    this._initialData = structuredClone(this.data);
  }
}
